const autoNgTemplateLoaderTemplate1 = require('./storidgeSnapshotCreation.html');

angular.module('shbdeployer.docker').component('storidgeSnapshotCreation', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'StoridgeSnapshotCreationController',
  bindings: {
    volumeId: '<',
  },
});
